import { ImageWrapper } from '../../../common/wrappers/ImageWrapper';
import { zdarEscapeGameCipher23Images } from '../../../../configuration/games/zdar-escape-game/zdarEscapeGameCipher23Images';
import React from 'react';
import dots from '../../../../assets/images/games/zdar-escape-game/ciphers/23/dots.webp';

type Props = {
    label?: string;
};
export default function ZdarTreesCipher({ label }: Props) {
    return (
        <React.Fragment>
            <div className="zdar-trees-cipher">
                <div className="cipher-wrapper zdar-cipher-pathfinder">
                    {zdarEscapeGameCipher23Images.map((image, i) => {
                        return (
                            <div key={i} className="cipher-image">
                                <ImageWrapper src={image} alt="cipher" shouldScroll={true} allowLightbox={false} />
                            </div>
                        );
                    })}
                </div>
                <div className="zdar-cipher-text-wrapper">
                    <div className="zdar-cipher--label">{label}</div>
                    <div className="zdar-cipher-text">
                        Zjistěte, kde se nachází dané fotografie a potom je spojte mezi sebou.
                    </div>
                    <div className="cipher-image">
                        <ImageWrapper src={dots} alt="cipher" shouldScroll={true} allowLightbox={false} />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
